import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '@/lib/firebase';

interface AdminNotificationCounts {
  pendingUnits: number;
  total: number;
  loading: boolean;
}

export function useAdminNotifications(enabled: boolean = false) {
  const [counts, setCounts] = useState<AdminNotificationCounts>({
    pendingUnits: 0,
    total: 0,
    loading: true,
  });

  useEffect(() => {
    if (!enabled) {
      setCounts({
        pendingUnits: 0,
        total: 0,
        loading: false,
      });
      return;
    }

    const fetchNotificationCounts = async () => {
      try {
        // Fetch pending units count
        const pendingUnitsQuery = query(
          collection(db, 'units'),
          where('reviewStatus', '==', 'pending')
        );
        const pendingUnitsSnapshot = await getDocs(pendingUnitsQuery);
        const pendingUnitsCount = pendingUnitsSnapshot.size;

        // Calculate total
        const total = pendingUnitsCount;

        setCounts({
          pendingUnits: pendingUnitsCount,
          total,
          loading: false,
        });
      } catch (error) {
        console.error('Error fetching admin notification counts:', error);
        setCounts({
          pendingUnits: 0,
          total: 0,
          loading: false,
        });
      }
    };

    fetchNotificationCounts();

    // Refresh every 2 minutes
    const interval = setInterval(fetchNotificationCounts, 2 * 60 * 1000);

    return () => clearInterval(interval);
  }, [enabled]);

  return counts;
}




